/* eslint-disable import/prefer-default-export */

import { loanStatusOptions } from "web_modules/shared/loan_statuses";

// selectable / displayed loan statuses:

// if currently a deprecated loan status, then add that particular deprecated loan status.

export const visibleLoanStatusOptions = (currentLoanStatus: string) => {
  const currentLoanStatusOption = loanStatusOptions.find(
    option => option.value === currentLoanStatus,
  );

  const isDeprecated = currentLoanStatusOption && currentLoanStatusOption.deprecated;

  let visibleLoanStatuses = loanStatusOptions.filter(option => !option.deprecated);
  if (isDeprecated) {
    visibleLoanStatuses = [...visibleLoanStatuses, currentLoanStatusOption];
  }

  return visibleLoanStatuses;
};
